<script>
  import Link from '../../../utils/link';
  import Card from '../../../components/containers/card.html';
  import Avatar from '../../../components/containers/avatar.html';

  export let coordinator;

  function getCoordinatorLink() {
    return `/coordinators/view/${coordinator.id}`;
  }
</script>

<Card hover>
  <Link href={getCoordinatorLink()}>
    <div class="u--padall">
    <div class="grid-x grid-margin-x">
     <div class="cell small-12 medium-12 text-center">
        <Avatar larger avatar={coordinator.avatar} />
      </div>
      <div class="cell small-12 medium-12 text-center">
        <div class="u--padall">
          <h3>
            {coordinator.firstName} {coordinator.lastName}
          </h3>
        </div>
      </div>
    </div>
  </div>
  </Link>
</Card>


